import React, { useState } from "react";
import Header from "./Header";
import Review from "./Review";

const Reviews = ({ books, initialData, searchTerm }) => {
  const combinedBooks = initialData.concat(books);

  // sort by rank
  let sorted = combinedBooks.sort((a, b) => {
    return b.score - a.score;
  });

  //   sort by alphabetical order
  let newSorted = sorted.sort(function (a, b) {
    let fa = a.title.toLowerCase(),
      fb = b.title.toLowerCase();

    if (fa < fb) {
      return -1;
    }
    if (fa > fb) {
      return 1;
    }
    return 0;
  });

  //   sort by rank then alphabetically
  let newerSorted = [...newSorted].sort((a, b) => {
    return b.score - a.score;
  });

  return (
    <section>
      <Header title="리뷰 내역" />

      {/* search input to find the book review by title */}

      {newerSorted
        .filter(({ title }) =>
          title.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .map(({ title, comment, score }, index) => (
          <Review key={index} title={title} comment={comment} score={score} />
        ))}
    </section>
  );
};

export default Reviews;
